const server_origin = "https://api.udyamuplift.in";
// const server_origin = 'http://localhost:5000';


export {server_origin};